export default {
  title: 'Portale Ordini',
  form: {
    username: {
      placeholder: 'Nome utente',
    },
    password: {
      placeholder: 'Password',
    },
  },
  buttons: {
    submit: 'Accedi',
  },
  toasts: {
    auth_token_invalid: 'Il token di autenticazione fornito non è valido, accedi con le credenziali',
    credentials_invalid: 'Nome utente o password errati',
  },
};
